import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { loginUrl } from "../urls";
import { deleteRegisterNotificationToken } from "../../../../../screen/distributor/action/util_action";
import { logoutAction } from "../../../../../screen/auth/action";
import store from "../../../../../utils/store";
import { toast } from "react-toastify";

let responseInterceptorId = null;
let isHandlingUnauthorized = false;
let suppressNonSessionErrorToasts = false;

const SESSION_EXPIRED_MESSAGE = "Session expired. Please connect with your firm owner";
const SESSION_EXPIRED_TOAST_ID = "session-expired-401";

const originalToastError = toast.error.bind(toast);

if (!toast.__hb401ToastPatched) {
  toast.error = (message, options) => {
    if (
      suppressNonSessionErrorToasts &&
      typeof message === "string" &&
      message !== SESSION_EXPIRED_MESSAGE
    ) {
      return null;
    }
    return originalToastError(message, options);
  };
  toast.__hb401ToastPatched = true;
}

const redirectToLogin = () => {
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

const setup401ResponseInterceptor = () => {
  if (responseInterceptorId !== null) return;

  responseInterceptorId = axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;

      if (status === 401 && !isHandlingUnauthorized) {
        isHandlingUnauthorized = true;
        suppressNonSessionErrorToasts = true;
        toast.dismiss();
        toast.error(SESSION_EXPIRED_MESSAGE, {
          toastId: SESSION_EXPIRED_TOAST_ID,
        });
        try {
          await store.store.dispatch(logoutUser());
        } catch (_e) {
          localStorage.clear();
          store.store.dispatch({ type: "LOGOUT" });
        } finally {
          setTimeout(() => {
            redirectToLogin();
            isHandlingUnauthorized = false;
            suppressNonSessionErrorToasts = false;
          }, 1000); // Give user time to see the toast
        }
      }
      return Promise.reject(error);
    },
  );
};

setup401ResponseInterceptor();

export const LoginAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${loginUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};

export const logoutUser = () => async (dispatch)  =>{
  const userToken = JSON.parse(localStorage.getItem('message_token'));
      await deleteRegisterNotificationToken(userToken);
      await logoutAction();
      localStorage.clear();
      dispatch({ type: 'LOGOUT' });
}
